import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class ServiceGroupApi extends EntityApi {
    protected static GET_COLLECTION = "/api/service-groups";

    protected static POST_COLLECTION = "/api/service-groups";

    protected static GET_ITEM = "/api/service-groups/{id}";

    protected static PUT_ITEM = "/api/service-groups/{id}";

    protected static PATCH_ITEM = "/api/service-groups/{id}";

    protected static DELETE_ITEM = "/api/service-groups/{id}";

    protected static GET_COLLECTION_FOR_SELECT = "/api/service-groups/select";

    public static async getCollectionForSelect<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FOR_SELECT,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
